
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refer-friend",
      function () {
        return require("private-next-pages/refer-friend.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refer-friend"])
      });
    }
  